module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductComments":{"empty":"Zatím nikdo nekomentoval."}},"de":{"ProductComments":{"empty":"Bisher hat sich niemand dazu geäußert."}},"sk":{"ProductComments":{"empty":"Zatiaľ nikto nekomentoval."}}}')
  delete Component.options._Ctor
}
